(() => {
  if (customElements.get('nskin-catalog')) return;
  class NSkinCatalog extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-filter-form]');
      this.grid = this.querySelector('[data-items]');
      this.labels = JSON.parse(this.querySelector('[data-catalog-labels]').textContent);
      this.formatPrice = value => value === null ? this.labels.pricePending : new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(value);
      this.form.addEventListener('submit', event => event.preventDefault());
      try {
        const response = await fetch(this.dataset.previewUrl);
        if (!response.ok) throw new Error('Catalogue unavailable');
        const catalogue = await response.json();
        this.previewProducts = catalogue.filter(product => this.dataset.preview === 'true' || /essel/i.test(product.vendor));
        this.previewProducts.forEach(product => { if (/essel/i.test(product.vendor)) product.price = null; });
        this.previewProducts.forEach((product, index) => this.addPreviewCard(product, index));
        this.items = Array.from(this.querySelectorAll('[data-catalog-item]'));
        this.items.forEach((item, index) => item.dataset.order = index);
        const brands = [...new Set(this.items.map(item => item.dataset.brand))].sort((a, b) => a.localeCompare(b));
        const select = this.form.elements.brand;
        brands.forEach(brand => select.add(new Option(brand, brand)));
        this.readUrl();
        this.render(false);
        this.form.addEventListener('change', () => this.render(true));
        this.form.addEventListener('input', event => { if (event.target.type === 'number') this.render(true); });
        this.querySelector('[data-clear]').addEventListener('click', () => { this.form.reset(); this.render(true); });
        window.addEventListener('popstate', () => { this.readUrl(); this.render(false); });
        document.querySelectorAll('[data-shop-needs]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.form.reset();
          const needs = link.dataset.shopNeeds.split(',').map(value => value.toLowerCase());
          this.form.querySelectorAll('[name=need]').forEach(input => input.checked = needs.includes(input.value.toLowerCase()));
          this.render(true);
          this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }));
        this.querySelector('[data-close]').addEventListener('click', () => this.querySelector('[data-product-dialog]').close());
      } catch (error) {
        this.querySelector('[data-count]').textContent = this.labels.error;
      }
    }
    addPreviewCard(product, index) {
      const item = document.createElement('li');
      item.dataset.catalogItem = '';
      item.dataset.brand = product.vendor;
      item.dataset.price = product.price === null ? '' : product.price;
      item.dataset.title = product.title;
      item.dataset.needs = product.needs.join('|');
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'nskin-catalog__card';
      const media = document.createElement('span'); media.className = 'nskin-catalog__media';
      if (product.image) {
        const image = document.createElement('img');
        const url = new URL(product.image); url.searchParams.set('width', '700');
        image.src = url.toString(); image.alt = product.title; image.loading = 'lazy'; image.decoding = 'async'; image.width = 700; image.height = 700;
        media.append(image);
      } else {
        const pending = document.createElement('span'); pending.textContent = this.labels.imagePending; media.append(pending);
      }
      const brand = document.createElement('span'); brand.className = 'nskin-catalog__brand'; brand.textContent = product.vendor;
      const title = document.createElement('span'); title.className = 'nskin-catalog__product-title'; title.style.cssText = 'display:block;font:400 25px/1.24 Georgia,serif;margin:0 0 14px;color:#2e3529'; title.textContent = product.title;
      const price = document.createElement('span'); price.className = 'nskin-catalog__money'; price.textContent = /essel/i.test(product.vendor) ? this.labels.clinicOnly : this.formatPrice(product.price);
      button.append(media, brand, title, price); item.append(button); this.grid.append(item);
      button.addEventListener('click', () => this.showProduct(index));
    }
    readUrl() {
      const params = new URL(window.location.href).searchParams;
      this.form.elements.brand.value = params.get('brand') || '';
      this.form.elements.min.value = params.get('min') || '';
      this.form.elements.max.value = params.get('max') || '';
      this.form.elements.sort.value = params.get('sort') || 'featured';
      const category = { cleanse: ['cleansing'], hydrate: ['hydration'], protect: ['protection'], target: ['pigmentation', 'breakouts', 'sensitivity'] };
      const handle = window.location.pathname.split('/')[2];
      const needs = params.has('need') ? params.getAll('need').flatMap(value => value.split(',')).map(value => value.toLowerCase()) : (category[handle] || []);
      this.form.querySelectorAll('[name=need]').forEach(input => input.checked = needs.includes(input.value.toLowerCase()));
    }
    render(updateUrl) {
      const data = new FormData(this.form);
      const brand = data.get('brand');
      const min = data.get('min') === '' ? 0 : Math.max(0, Number(data.get('min')));
      const max = data.get('max') === '' ? Infinity : Math.max(0, Number(data.get('max')));
      const needs = data.getAll('need').map(value => value.toLowerCase());
      const sort = data.get('sort');
      const ordered = [...this.items].sort((a, b) => {
        if (sort.startsWith('price-') && (a.dataset.price === '' || b.dataset.price === '')) return (a.dataset.price === '' ? 1 : 0) - (b.dataset.price === '' ? 1 : 0);
        if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price) || a.dataset.title.localeCompare(b.dataset.title);
        if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price) || a.dataset.title.localeCompare(b.dataset.title);
        if (sort === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      let count = 0;
      ordered.forEach(item => {
        const price = Number(item.dataset.price);
        const tags = item.dataset.needs.split('|').map(value => value.toLowerCase());
        const visible = (!brand || item.dataset.brand === brand) && (item.dataset.price === '' ? data.get('min') === '' && data.get('max') === '' : price >= min && price <= max) && (!needs.length || needs.some(need => tags.includes(need)));
        item.hidden = !visible; if (visible) count++;
        this.grid.append(item);
      });
      this.querySelector('[data-count]').textContent = this.labels.count.replace('[count]', String(count)).replace('[total]', String(this.items.length));
      this.querySelector('[data-empty]').hidden = count > 0;
      if (updateUrl) {
        const url = new URL(window.location.href);
        ['brand', 'min', 'max', 'sort', 'need'].forEach(key => url.searchParams.delete(key));
        if (brand) url.searchParams.set('brand', brand);
        if (data.get('min') !== '') url.searchParams.set('min', data.get('min'));
        if (data.get('max') !== '') url.searchParams.set('max', data.get('max'));
        if (sort && sort !== 'featured') url.searchParams.set('sort', sort);
        data.getAll('need').forEach(need => url.searchParams.append('need', need.toLowerCase()));
        window.history.replaceState(null, '', url);
      }
    }
    showProduct(index) {
      const product = this.previewProducts[index]; const dialog = this.querySelector('[data-product-dialog]'); const image = dialog.querySelector('[data-detail-image]');
      image.hidden = !product.image;
      if (product.image) { image.src = product.image; image.alt = product.title; }
      dialog.querySelector('[data-detail-brand]').textContent = product.vendor;
      dialog.querySelector('[data-detail-title]').textContent = product.title;
      dialog.querySelector('[data-detail-price]').textContent = /essel/i.test(product.vendor) ? this.labels.clinicOnly : this.formatPrice(product.price);
      dialog.querySelector('[data-detail-description]').textContent = product.description;
      dialog.querySelector('.nskin-catalog__availability').textContent = /essel/i.test(product.vendor) ? this.labels.clinicOnly : this.labels.pricePending;
      dialog.querySelector('[data-detail-contact]').href = 'https://wa.me/27645134995?text=' + encodeURIComponent('Hi N SKIN, please can Namrata advise me on ' + product.title + '?');
      dialog.showModal();
    }
  }
  customElements.define('nskin-catalog', NSkinCatalog);
})();
